import { type LucideIcon } from 'lucide-react';
import clsx from 'clsx';

import { Icon } from '@@/Icon';

interface Props {
  icon: LucideIcon;
  label: string;
  value: string | number;
  size?: 'sm' | 'md' | 'lg';
}

export function StatBlock({ icon, label, value, size }: Props) {
  const longValueText = `${value}`.length > 12;

  return (
    <div
      className={clsx(
        'flex flex-col gap-1 rounded-lg border border-solid border-gray-5 bg-gray-2 px-4 py-3 th-highcontrast:border-white th-highcontrast:bg-gray-10 th-dark:border-gray-8 th-dark:bg-gray-iron-10',
        {
          'w-24': size === 'sm',
          'w-36': size === 'md',
          'w-48': size === 'lg',
          'min-w-[100px]': size === undefined,
        }
      )}
    >
      <div className="flex items-center gap-1.5 text-xs uppercase tracking-wider text-gray-7 th-highcontrast:text-gray-3 th-dark:text-gray-3">
        <Icon icon={icon} size="sm" />
        <span>{label}</span>
      </div>
      <span
        className={clsx(
          longValueText ? 'text-xs' : 'text-base',
          'font-semibold text-gray-9 th-highcontrast:text-white th-dark:text-white'
        )}
      >
        {value}
      </span>
    </div>
  );
}
